// extracted by mini-css-extract-plugin
module.exports = {"switchBase":"Switch_switchBase__3O2sP","checked":"Switch_checked__1NAtt"};